// © Microsoft Corporation. All rights reserved.

import { logger } from "@msnews/diagnostics";

export function contentIdKey(cmsId: string, market: string): string {
    return `${cmsId}_${market}`;
}

export function selectContentId(contentIds: { [id: string]: string }, cmsId: string, market: string): string {
    const key = contentIdKey(cmsId, market);
    const contentId = contentIds && contentIds[key];

    if (contentId) {
        return contentId;
    } else {
        logger.log("Content id doesn't exist, falling back to key `${cmsId}_${market}`");
        return key;
    }
}